import React from 'react'
import broker from "../../../../images/garden.png"

const BrokerLogIImage = () => {
  return (
    <div>
        <div className='blackgirl-image-text'>
        <div className='mt-10'>
            <img src={broker} alt=""/>
        </div>
        <h1 className="text-2xl font-medium text-left">Welcome Back</h1>
    </div>
    </div>
  )
}

export default BrokerLogIImage